/* Sepette kargo ucreti + toplam gosterimi.
   Fiyat /cart/shipping_rates.json uzerinden canli cekilir,
   boylece Shopify ayarlarindaki kargo ucreti degisince sepet de otomatik uyar. */
if (!customElements.get("shipping-estimate")) {
  /* Bazi ulkelerde (US, CA, GB...) Shopify posta kodu olmadan kargo dondurmuyor.
     Kargo ucreti ulke bazinda tek fiyat oldugu icin temsili bir adres yeterli.
     ONEMLI: ileride eyalet/bolge bazli farkli kargo ucretleri tanimlanirsa
     bu tablo yaniltici olur, o zaman gercek adres sorulmasi gerekir. */
  const ADDRESS_FALLBACKS = {
    US: { province: "NY", zip: "10001" },
    CA: { province: "ON", zip: "M5H 2N2" },
    GB: { province: "", zip: "SW1A 1AA" },
    AU: { province: "NSW", zip: "2000" },
    JP: { province: "", zip: "100-0001" },
    DE: { province: "", zip: "10115" },
    FR: { province: "", zip: "75001" },
    NL: { province: "", zip: "1011 AB" },
  };

  /* Shopify'in klasik para birimi bicimleyicisi.
     Temadaki ara toplam ile ayni gorunmesi icin magazanin kendi formatini kullaniyoruz. */
  function formatWithDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents === null) return "0";
    const number = (cents / 100).toFixed(precision);
    const parts = number.split(".");
    const whole = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands,
    );
    const fraction = parts[1] ? decimal + parts[1] : "";
    return whole + fraction;
  }

  function formatMoney(cents, format) {
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    if (!match) return format;

    let value = "";
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2, ",", ".");
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0, ",", ".");
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      default:
        return format;
    }
    return format.replace(placeholder, value);
  }

  class ShippingEstimate extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    cartBaseUrl() {
      if (window.routes && window.routes.cart_url) {
        return window.routes.cart_url;
      }
      if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
        return window.Shopify.routes.root.replace(/\/$/, "") + "/cart";
      }
      return "/cart";
    }

    buildUrl(country, address) {
      let url =
        this.cartBaseUrl() +
        "/shipping_rates.json?shipping_address%5Bcountry%5D=" +
        encodeURIComponent(country);
      if (address) {
        if (address.province) {
          url +=
            "&shipping_address%5Bprovince%5D=" +
            encodeURIComponent(address.province);
        }
        if (address.zip) {
          url +=
            "&shipping_address%5Bzip%5D=" + encodeURIComponent(address.zip);
        }
      }
      return url;
    }

    async fetchRates(country, address) {
      const response = await fetch(this.buildUrl(country, address), {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) return null;
      const data = await response.json();
      const rates = (data && data.shipping_rates) || [];
      return rates.length ? rates : null;
    }

    /* Sadece sepetin para birimiyle ayni olan fiyati kabul et.
       Eslesmezse hic gostermeyiz - yanlis rakam gostermektense bos birakiriz. */
    pickPrice(rate, currency) {
      if (rate.presentment_currency && rate.presentment_currency === currency) {
        return rate.presentment_price;
      }
      if (!rate.currency || rate.currency === currency) {
        return rate.price;
      }
      return null;
    }

    async render() {
      const country = this.dataset.country;
      const currency = this.dataset.currency;
      const cartTotal = parseInt(this.dataset.cartTotal, 10);

      if (!country || !currency || Number.isNaN(cartTotal)) return;

      let rates = null;

      /* 1. deneme: sadece ulke. TR gibi posta kodu istemeyen ulkelerde yeterli. */
      try {
        rates = await this.fetchRates(country, null);
      } catch (error) {
        rates = null;
      }

      /* 2. deneme: posta kodu zorunlu olan ulkeler icin temsili adres. */
      if (!rates && ADDRESS_FALLBACKS[country]) {
        try {
          rates = await this.fetchRates(country, ADDRESS_FALLBACKS[country]);
        } catch (error) {
          rates = null;
        }
      }

      if (!rates) {
        console.warn(
          "[shipping-estimate] kargo ucreti alinamadi. ulke:",
          country,
          "para birimi:",
          currency,
        );
        return;
      }

      const cheapest = rates.reduce((a, b) =>
        parseFloat(a.price) <= parseFloat(b.price) ? a : b,
      );

      const raw = this.pickPrice(cheapest, currency);
      if (raw === null || raw === undefined) {
        console.warn(
          "[shipping-estimate] kargo para birimi sepetle uyusmuyor:",
          cheapest.currency,
          "!=",
          currency,
        );
        return;
      }

      const shipping = Math.round(parseFloat(raw) * 100);
      if (Number.isNaN(shipping)) return;

      const shippingEl = this.querySelector("[data-shipping-value]");
      const totalEl = this.querySelector("[data-total-value]");
      if (!shippingEl || !totalEl) return;

      shippingEl.textContent = this.money(shipping, currency);
      totalEl.textContent = this.money(cartTotal + shipping, currency);
      this.hidden = false;
    }

    money(cents, currency) {
      const format = this.dataset.moneyFormat;
      const shopCurrency = this.dataset.shopCurrency;

      /* Sepet magaza para biriminde ise temanin kendi formatini kullan,
         boylece ara toplamla birebir ayni gorunur. */
      if (format && shopCurrency && shopCurrency === currency) {
        return formatMoney(cents, format);
      }

      const locale =
        this.dataset.locale || document.documentElement.lang || "tr";
      try {
        return new Intl.NumberFormat(locale, {
          style: "currency",
          currency: currency,
        }).format(cents / 100);
      } catch (error) {
        return (cents / 100).toFixed(2) + " " + currency;
      }
    }
  }

  customElements.define("shipping-estimate", ShippingEstimate);
}
